import { Paper, Stack, Typography } from "@mui/material";
import { Complain } from "../models/complain.model";
import LoadingButton from "../components/LoadingButton";
import { Question } from "../models/question.model";
import { titleStr } from "../lib/helper";
import SurveySubmitAnswerView from "../containers/SurveySubmitAnswerView";
import _ from "lodash";

export default function SurveyComplainDetails(props: {
  complain: Complain;
  questionAnswers: Record<string, any>;
  questions?: Question[];
  onEscalate: (complain: Complain) => Promise<void>;
}) {
  const { complain, questionAnswers, questions } = props;
  const complainQuestionAnswers: any = {};
  const normalQuestionAnswers: any = {};
  Object.entries(questionAnswers || {}).forEach(([key, value]) => {
    if (key.includes("complain_") || `${value || ""}`.includes("complain_")) {
      complainQuestionAnswers[key] = value;
    } else {
      normalQuestionAnswers[key] = value;
    }
  });

  return (
    <Stack spacing={3}>
      <Paper variant="outlined" sx={{ p: 2 }}>
        <Typography variant="subtitle2" fontWeight={"bold"} gutterBottom>
          Status
        </Typography>
        <Typography variant="body1" sx={{ mb: 2 }}>
          {titleStr(complain.status)}
        </Typography>
        <Stack direction={"row"} spacing={8} alignItems={"center"}>
          <Stack>
            <Typography variant="subtitle2" fontWeight={"bold"} gutterBottom>
              Escalate
            </Typography>
            <Typography variant="body1" sx={{ mb: 2 }}>
              {titleStr(complain.escalate)}
            </Typography>
          </Stack>
          <LoadingButton
            variant="outlined"
            color="error"
            onClick={async () => {
              await props.onEscalate(complain);
            }}
          >
            Mark as {complain.escalate === "yes" ? "Deescalate" : "Escalate"}
          </LoadingButton>
        </Stack>
      </Paper>
      <Paper variant="outlined" sx={{ p: 2 }}>
        <Typography variant="h6" sx={{ mb: 2 }}>
          Complain Details
        </Typography>
        <SurveySubmitAnswerView answers={complainQuestionAnswers} questions={questions} />
      </Paper>
      <Paper variant="outlined" sx={{ p: 2 }}>
        <Typography variant="h6" sx={{ mb: 2 }}>
          Answers
        </Typography>
        <SurveySubmitAnswerView answers={normalQuestionAnswers} questions={questions} />
      </Paper>
    </Stack>
  );
}
